// extracted by css-extract-rspack-plugin
export default {"affirmative":"Affirmative-module__affirmative__lo8bBNO","copilotRun":"Affirmative-module__copilotRun__nnefqFx"};